import { render, staticRenderFns } from "./OtherCashPaymentReg.vue?vue&type=template&id=298ceac2&"
import script from "./OtherCashPaymentReg.vue?vue&type=script&lang=js&"
export * from "./OtherCashPaymentReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports